import {
	SELECTING_SITE_ID,
	SELECTING_DIRECTORY,
	SELECTING_ELEMENTS,
	SELECTING_SERVER_ID
} from '../../constants/selectedElement';

const initialState = {
	siteId: null,
	directory: '',
	selectedElements: [],
	server_id: null
};

function selectedElementReducer(state = initialState, action) {
	switch (action.type) {
		case SELECTING_SITE_ID:
			return {
				...state,
				siteId: action.payload
			};
		case SELECTING_DIRECTORY:
			return {
				...state,
				directory: action.payload
			};
		case SELECTING_ELEMENTS:
			return {
				...state,
				selectedElements: action.payload
			};
		case SELECTING_SERVER_ID:
			return {
				...state,
				server_id: action.payload
			};
		default:
			return state;
	}
}

export default selectedElementReducer;
